import { Box, Divider, Grid, Rating, styled, Typography } from '@mui/material';

export const BasicDetailsContainer = styled(Box)`
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const TitleTypography = styled(Box)`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  text-transform: capitalize;
  color: #0f1111;
`;

export const BasicTitleTypography = styled(Typography)`
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  text-transform: capitalize;
  color: #0f1111;
  display: flex;
  gap: 4px;
  flex-direction: row;
  align-text: left;
`;

export const ValueTypography = styled(Typography)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #0f1111;
  text-align: left;
  white-space: normal !important;
  word-wrap: break-word !important;
`;

export const DividerStyled = styled(Divider)`
  margin: -1px;
  margin-top: 8px;
`;

export const BorderGrid = styled(Grid)``;

export const CoreFlexGrid = styled(Grid)`
  display: flex;
  padding-top: 20px !important;
`;

export const StyledRating = styled(Rating)`
  color: #D6BA28;
`;